export default "__VITE_ASSET__CG8d5qMx__"